import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Years } from 'interfaces';
import { AppLocale } from 'constant';

import { LanguageContext } from 'context/languageContext';

import {
  AddText,
  List,
  ListItem,
  ListLink,
  NumberWrapper,
  Wrapper
} from './ConcertYearsList.styles';

export interface ConcertYearsListProps {
  list: Years;
  className?: string;
  isConcertsFestivals?: boolean;
}

const ConcertYearsList = ({ list, isConcertsFestivals = false, className = '' }: ConcertYearsListProps) => {
  const { locale } = useContext(LanguageContext);
  const intl = useIntl();

  return (
    <Wrapper className={className}>
      <List>
        {
          Object.entries(list).map(([year, concerts]) => (
            <ListItem key={year}>
              <ListLink to={isConcertsFestivals ? `/tours-and-shows/shows/festivals-shows-special-events/${year}` : `/tours-and-shows/shows/${year}`}>
                <span>{intl.formatDate(year, { year: 'numeric' })}</span>
              </ListLink>
              <NumberWrapper>{concerts.length}</NumberWrapper>
              {
                locale === AppLocale.JP ? (
                  <AddText>{intl.formatMessage({ id: 'statisticSidebar.onTours.shows' })}</AddText>
                ) : null
              }
            </ListItem>
          ))
        }
      </List>
    </Wrapper>
  );
};

export default ConcertYearsList;
